// extracted by mini-css-extract-plugin
export var content = "_6a-1";
export var modal = "_6a-0";